const authenticationResults = ['AUTHENTICATION_SUCCESS', 'AUTHENTICATION_TIMEOUT'] as const;
type AuthenticationResult = typeof authenticationResults[number];

export const authenticationResultValueFormatter = (value: AuthenticationResult) => {
  switch (value) {
    case 'AUTHENTICATION_SUCCESS':
      return 'Authentication success';
    case 'AUTHENTICATION_TIMEOUT':
      return 'Authentication timeout';
    default:
      return value;
  }
};
